import type { PropsWithChildren } from 'react';

import classNames from 'classnames';

import styles from './DialogBody.module.scss';

interface DialogBodyProps {
  className?: string;
}

const DialogBody = ({ className, children }: PropsWithChildren<DialogBodyProps>) => {
  return (
    <div className={ classNames(className, styles.container)}>
      {children}
    </div>
  );
};

export {
  DialogBody,
  type DialogBodyProps,
}
